import { useContext } from "react";

import AuthContext from "context/auth/authContext";
import { useMediaQueries } from "shared/hooks/useMediaQueries";

import DeviceStatisticsDesktop from "./DeviceStatisticsDesktop";
import DeviceStatisticsMobile from "./DeviceStatisticsMobile";

const DeviceStatistics = () => {
    const { isSupportUser } = useContext(AuthContext);
    const { toMd } = useMediaQueries();

    const renderData = () => {
        if (isSupportUser) return null;

        return toMd ? <DeviceStatisticsMobile /> : <DeviceStatisticsDesktop />;
    };

    return renderData();
};

export default DeviceStatistics;
